<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Descripción" campo="descripcion" />
      <th-ordenado titulo="Factor" campo="factorCorreccion" />
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-if="!complejidadesProyecto" :colspan="3" />
      <tr v-for="complejidadProyecto in complejidadesProyecto" :key="complejidadProyecto.id" role="button">
        <td @click="editarComplejidadesProyecto(complejidadProyecto.id)">
          {{ complejidadProyecto.descripcion }}
        </td>
        <td class="text-center" @click="editarComplejidadesProyecto(complejidadProyecto.id)">
          {{ complejidadProyecto.factorCorreccion }}
        </td>
        <td nowrap="nowrap" class="td-acciones">
          <b-button-group size="sm">
            <b-button
              variant="primary"
              class="actionButton"
              :to="`/complejidadesProyecto/editar/${complejidadProyecto.id}`"
            >
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    complejidadesProyecto: Array,
  },
  methods: {
    editarComplejidadesProyecto(complejidadProyectoId) {
      this.$router.push("/complejidadesProyecto/editar/" + complejidadProyectoId);
    },
  },
};
</script>
